@if (
  {
    cities: citiesListener?.data$ | async,
    citiesLoadingError: citiesListener?.errorLoading$,
    districts: districtsListener?.data$ | async,
    districtsLoadingError: districtsListener?.errorLoading$,
    isSubmitting: isSubmitting(),
    currentStepIndex: currentStepIndex(),
    paymentId: paymentId(),
    transactionStatus: transactionStatus()
  };
  as STATE
) {
  <article class="buy-stickers-form">
    <custom-modal-card
      [enableClose]="STATE.currentStepIndex !== 2"
      [enableHelpSection]="STATE.currentStepIndex === 0"
      helpSectionLink="https://docs.fneci.net/gestion-stickers#achat"
    >
      <ng-container header>
        <ng-container header>
          <default-modal-header
            [title]="'Achat de stickers'"
            [description]="
              'Veuillez renseigner les champs ci-dessous pour acheter des stickers'
            "
          ></default-modal-header>
        </ng-container>
      </ng-container>

      <ng-container body>
        <mat-stepper
          class="buy-stickers-stepper"
          [ngClass]="{
            'force-last-done': currentStepIndex() >= 2,
            'second-stepper': currentStepIndex() === 1
          }"
          #stepper
          [linear]="false"
          animationDuration="0"
          [selectedIndex]="STATE.currentStepIndex"
        >
          <ng-template matStepperIcon="number" let-index="index">
            {{ index + 1 }}
          </ng-template>
          <ng-template matStepperIcon="edit" let-index="index">
            {{ index + 1 }}
          </ng-template>
          <ng-template matStepperIcon="done" let-index="index">
            {{ index + 1 }}
          </ng-template>

          <mat-step
            [stepControl]="form"
            [state]="STATE.currentStepIndex === 0 ? 'edit' : 'done'"
            [editable]="false"
            [completed]="STATE.currentStepIndex > 0"
          >
            <form [formGroup]="form" class="buy-stickers-form__form">
              <!-- Identification de paiement -->
              <section
                class="buy-stickers-form__section buy-stickers-form__section--payment"
              >
                <hgroup class="buy-stickers-form__section__header">
                  <h3 class="buy-stickers-form__section__header__title">
                    Identification de paiement
                  </h3>
                </hgroup>
                <div
                  class="buy-stickers-form__section__content"
                  formGroupName="invoice"
                >
                  <div class="buy-stickers-form__form__row">
                    <article>
                      <mat-label for="firstName"
                        >Nom<span class="form__label--required">
                          *</span
                        ></mat-label
                      >
                      <mat-form-field
                        floatLabel="always"
                        [subscriptSizing]="'dynamic'"
                      >
                        <input
                          matInput
                          id="firstName"
                          formControlName="firstName"
                          required
                          placeholder="Saisir le nom"
                        />
                        @if (
                          firstNameControl?.errors?.required &&
                          firstNameControl?.touched
                        ) {
                          <mat-error
                            [innerHtml]="'Le nom est requis'"
                            class="form__error-red"
                          >
                          </mat-error>
                        }
                      </mat-form-field>
                    </article>
                    <article>
                      <mat-label for="lastName"
                        >Prénom(s)<span class="form__label--required">
                          *</span
                        ></mat-label
                      >
                      <mat-form-field
                        floatLabel="always"
                        [subscriptSizing]="'dynamic'"
                      >
                        <input
                          matInput
                          id="lastName"
                          formControlName="lastName"
                          required
                          placeholder="Saisir le prénom"
                        />
                        @if (
                          lastNameControl?.errors?.required &&
                          lastNameControl?.touched
                        ) {
                          <mat-error
                            [innerHtml]="'Le prénom est requis'"
                            class="form__error-red"
                          >
                          </mat-error>
                        }
                      </mat-form-field>
                    </article>
                  </div>

                  <div class="buy-stickers-form__form__row">
                    <article>
                      <mat-label for="city"
                        >Ville<span class="form__label--required">
                          *</span
                        ></mat-label
                      >
                      @if (STATE.cities) {
                        <div
                          class="form__item form__item--with-prefix relative"
                        >
                          <ng-select
                            [items]="$any(STATE.cities)"
                            multiple="false"
                            clearable="true"
                            bindLabel="label"
                            appendTo="body"
                            bindValue="value"
                            clearAllText="Effacer"
                            placeholder="Veuillez saisir la ville"
                            formControlName="city"
                            (change)="_initDistrictsListener($event?.value)"
                          >
                          </ng-select>
                        </div>
                      } @else {
                        <loading-or-error
                          (retry)="_initCitiesListener()"
                          [error$]="STATE.citiesLoadingError"
                          spinnerSize="sm"
                        ></loading-or-error>
                      }

                      @if (
                        cityControl?.errors?.required && cityControl?.touched
                      ) {
                        <span class="form__error-red text-sm mt-1 block">
                          La ville est requise
                        </span>
                      }
                    </article>
                    <article>
                      <mat-label for="district"
                        >Commune<span class="form__label--required">
                          *</span
                        ></mat-label
                      >
                      @if (STATE.districts) {
                        <div class="form__item form__item--with-prefix">
                          <ng-select
                            [items]="$any(STATE.districts)"
                            bindLabel="label"
                            clearable="false"
                            appendTo="body"
                            bindValue="value"
                            clearAllText="Effacer"
                            placeholder="Veuillez Saisir la commune"
                            formControlName="district"
                          >
                          </ng-select>
                        </div>
                        @if (
                          districtControl?.errors?.required &&
                          districtControl?.touched
                        ) {
                          <span class="form__error-red text-sm mt-1 block">
                            La commune est requise
                          </span>
                        }
                      } @else {
                        <loading-or-error
                          (retry)="_initDistrictsListener('ABIDJAN')"
                          [error$]="STATE.districtsLoadingError"
                          spinnerSize="sm"
                        ></loading-or-error>
                      }
                    </article>
                  </div>

                  <article>
                    <mat-label for="address"
                      >Adresse<span class="form__label--required">
                        *</span
                      ></mat-label
                    >
                    <mat-form-field
                      floatLabel="always"
                      [subscriptSizing]="'dynamic'"
                    >
                      <input
                        matInput
                        id="address"
                        formControlName="addressLine"
                        required
                        placeholder="Saisir l'adresse"
                      />
                      @if (
                        addressLineControl?.errors?.required &&
                        addressLineControl?.touched
                      ) {
                        <mat-error class="form__error-red">
                          L'adresse est requise
                        </mat-error>
                      }
                    </mat-form-field>
                  </article>
                </div>
              </section>

              <hr />

              <!-- Informations de paiement -->
              <section class="buy-stickers-form__section">
                <hgroup class="buy-stickers-form__section__header">
                  <h3
                    class="font-bold buy-stickers-form__section__header__title"
                  >
                    Informations de paiement
                  </h3>
                </hgroup>

                <div class="buy-stickers-form__section__content">
                  <p>Veuillez choisir la méthode de paiement :</p>
                  <mat-tab-group animationDuration="0ms" class="">
                    <mat-tab label="Mobile Money">
                      <mat-radio-group
                        formControlName="paymentMethod"
                        aria-label="Selectionner un moyen de paiement mobile money"
                      >
                        @for (
                          provider of mobileMoneyProviders;
                          track provider.id
                        ) {
                          <div
                            class="buy-stickers-form__radio-button"
                            [class.is-selected]="
                              paymentMethodControl?.value === provider.id
                            "
                            [class.is-unselected]="
                              paymentMethodControl?.value &&
                              paymentMethodControl?.value !== provider.id
                            "
                          >
                            <mat-radio-button
                              [value]="provider.id"
                              class="relative"
                            >
                              <img
                                [ngSrc]="provider.icon"
                                width="60"
                                height="60"
                                [alt]="provider.alt"
                                class="rounded-full"
                              />
                            </mat-radio-button>
                            <span>{{ provider.name }}</span>
                          </div>
                        }
                      </mat-radio-group>
                      @if (
                        paymentMethodControl?.errors?.required &&
                        paymentMethodControl?.touched
                      ) {
                        <span class="form__error-red text-sm mt-2 block">
                          La méthode de paiement est requise
                        </span>
                      }
                    </mat-tab>
                    <mat-tab label="Carte bancaire" [disabled]="true">
                      <ng-template mat-tab-label>
                        <span
                          tooltip="Méthode de paiement indisponible"
                          class="cursor-not-allowed"
                          >Carte bancaire</span
                        >
                      </ng-template>
                      Content 2
                    </mat-tab>
                    <mat-tab label="Virement bancaire" [disabled]="true">
                      <ng-template mat-tab-label>
                        <span
                          tooltip="Méthode de paiement indisponible"
                          class="cursor-not-allowed"
                          >Virement bancaire</span
                        >
                      </ng-template>
                      Content 3
                    </mat-tab>
                  </mat-tab-group>
                </div>

                <div class="buy-stickers-form__section__content">
                  <div class="buy-stickers-form__form__row">
                    <article>
                      <phone-field
                        uniqueId="phoneNumber"
                        label="Téléphone"
                        formControlName="phoneNumber"
                        [preferredCountries]="['CI']"
                        [readonly]="isSandboxEnvironment"
                      >
                        @if (
                          phoneNumberControl?.touched &&
                          phoneNumberControl?.errors?.required
                        ) {
                          <mat-error [innerHtml]="'Ce champ est requis'">
                          </mat-error>
                        }
                      </phone-field>
                    </article>

                    <article formGroupName="amount">
                      <mat-label for="amount"
                        >Montant du rechargement<span
                          class="form__label--required"
                        >
                          *</span
                        ></mat-label
                      >
                      <mat-form-field
                        floatLabel="always"
                        [subscriptSizing]="'dynamic'"
                      >
                        <input
                          matInput
                          id="amount"
                          formControlName="amount"
                          mask="separator.0"
                          thousandSeparator=" "
                          [outputTransformFn]="parseNumberFn"
                          required
                          placeholder="Entrer le montant"
                          integerOnly
                        />
                        @if (
                          amountControl?.errors?.min && amountControl?.touched
                        ) {
                          <mat-error
                            [innerHtml]="'Le montant minimum est de 1 FCFA'"
                            class="form__error-red"
                          >
                          </mat-error>
                        }

                        @if (
                          amountControl?.errors?.required &&
                          amountControl?.touched
                        ) {
                          <mat-error
                            [innerHtml]="'Le montant est requis'"
                            class="form__error-red"
                          >
                          </mat-error>
                        }
                      </mat-form-field>
                    </article>
                  </div>
                </div>
              </section>
            </form>
          </mat-step>

          <mat-step
            [completed]="STATE.currentStepIndex > 1"
            [state]="
              STATE.currentStepIndex === 1
                ? 'edit'
                : STATE.currentStepIndex > 1
                  ? 'done'
                  : 'number'
            "
            [editable]="false"
          >
            <article class="buy-stickers-form__confirmation-step">
              <img
                [ngSrc]="'assets/images/secure-mobile-payment.svg'"
                width="100"
                height="100"
                alt="Check"
              />
              <h2 class="buy-stickers-form__confirmation-step__title">
                Paiement en attente de confirmation
              </h2>
              <p class="buy-stickers-form__confirmation-step__description">
                Merci de procéder à la validation de l’opération sur votre
                téléphone ou via votre service de paiement afin de finaliser
                l’opération
              </p>

              <span> </span>
              <loader size="xl" additionalClasses="text-success"></loader>
            </article>
          </mat-step>

          <mat-step
            [editable]="false"
            [completed]="STATE.currentStepIndex >= 2"
            [state]="STATE.currentStepIndex >= 2 ? 'done' : 'number'"
          >
            @if (STATE.paymentId && currentStepIndex() === 2) {
              <stickers-payment-status
                [paymentId]="STATE.paymentId"
                [transactionStatus]="STATE.transactionStatus"
              ></stickers-payment-status>
            }
          </mat-step>
        </mat-stepper>
      </ng-container>

      <ng-container footer>
        <div
          class="buy-stickers-form__form__footer"
          *ngIf="currentStepIndex() === 0"
        >
          <button
            button
            variant="primaryLight"
            [size]="'md'"
            (click)="onSubmit()"
            [loading]="STATE.isSubmitting"
            [loadingText]="'Paiement en cours...'"
            [disabled]="!form.valid || STATE.isSubmitting || form.pristine"
          >
            Passer la commande
          </button>
        </div>
      </ng-container>
    </custom-modal-card>
  </article>
}
